function buildStaticPageGroqQuery(slug: string): string {
    return `
    *[_type == 'staticPage' && coalesce(localePath.en.current, path.current) == "${slug}"][0] {
      ...,
      "widgets": widgets[]{
        _type == 'callToActionWidget' => {
          ...,
          "callToActionContent": callToActionContent[]{
            _type == 'callToAction' => {
              ...,
              image {
                ...,
                en {
                  ...,
                  asset->
                }
              }
            }
          }
        },
        _type == 'imageWidget' => {
          ...,
          image {
            ...,
            en {
              ...,
              asset->
            }
          }
        },
        _type != 'imageWidget' && _type != 'callToActionWidget' => @
      }
    }
  `;
}

export type StaticPageResult = { _id: string; [key: string]: any };

export async function fetchStaticPageBySlug(
    groqEndpoint: string,
    slug: string,
    signal?: AbortSignal
): Promise<StaticPageResult> {
    const url = new URL(groqEndpoint);
    url.searchParams.set('query', buildStaticPageGroqQuery(slug));

    const response = await fetch(url, { signal });
    const { result } = await response.json();

    return result as StaticPageResult;
}
